module.exports = __webpack_public_path__ + "img/bg-mobile.82038790.png";